import {Button, Col, Input, Row, Tooltip} from "antd";
import {
    C240SlideStatus,
    c240TaskType,
    cassetteType,
    globalConfigurations,
    queueActions,
    slideType
} from "../../utils/const";
import {
    CloseCircleOutlined,
    EyeOutlined,
    ScanOutlined,
    DownOutlined,
    DoubleLeftOutlined
} from "@ant-design/icons";
import CaseSearchInputComponent from "../../component/scanner/scanWorkflow/c240_case_search_component";
import {getLoggedInUserId, isTrue} from "../../utils/utils";
import React, {Component} from "react";
import {updateFolderName, updateSlideName} from "../../redux_actions/preview_status.action";
import {connect, useDispatch, useSelector} from "react-redux";
import {
    appendToQueue,
    callScannerServer,
    getLastEntryOfSlideInQueue,
    getObjectDifference,
    getRackTrayFromCassetteKey,
    queueScan, updateQueueUIUtility
} from "./utils";
import {getDeviceStatus} from "../../redux_actions/device_status.action";
import {getC240Status} from "../../redux_actions/c240_device_status.action";
import {aclPermissions, hasPermissions} from "../../const/ACLPermissions";
import CancelOutlined from "@mui/icons-material/CancelOutlined";

const SlideInQueueComponent = ({index, queueElems, rack, tray, prioritiseTask, removeTask, deprioritiseTask}) => {
    let indexOfLastEntry = getLastEntryOfSlideInQueue(rack, tray, index, queueElems);
    let value = indexOfLastEntry === -1 ? null : queueElems[indexOfLastEntry];
    return (
        indexOfLastEntry !== -1 ?
            <div style={{marginLeft: '25px'}}>
                {indexOfLastEntry !== 0 ?
                    <Button
                        className="scan-btn change-order-button"
                        onClick={(e) => {
                            prioritiseTask(e, rack, tray, index, value["taskType"])
                        }}
                    >
                        <DoubleLeftOutlined style={{transform: "rotate(90deg)"}} />
                        <span> Prioritise Task </span>
                    </Button>
                    : null}
                {indexOfLastEntry !== queueElems.length-1 ?
                    <Button
                        className="scan-btn change-order-button"
                        onClick={(e) => {
                            deprioritiseTask(e, rack, tray, index, value["taskType"])
                        }}
                    >
                        <DownOutlined fontSize={'small'}/>
                        <span> De-Prioritise Task </span>
                    </Button>
                    : null}
                <Button
                    className="scan-btn change-order-button"
                    onClick={(e) => {
                        removeTask(e, rack, tray, index, value["taskType"])
                    }}
                >
                    <CloseCircleOutlined />
                    <span> Cancel Task </span>
                </Button>
            </div> : null
    );
}

const PreviewDoneComponent = (props) => {
    let {index, slideStatus, barcodeVerify, scanButtonStatus,
        removeQueueInteraction, deviceId} = props;
    const isCalibrationPreview = ((slideStatus || {}).previewResponse || {}).beingUsedForPreviewCalibration
    let isValidSlideName = (nameToCheck) => {
        return true;
    }

    const dispatch = useDispatch();
    const previewStatus = useSelector((state) => state.previewStatusReducer);

    const enoughScanArea = ((slideStatus || {}).previewResponse || {}).enoughScanArea;
    const addFolderAtPreview = globalConfigurations["ADD_TO_FOLDER_AT_PREVIEW"] === "true";
    let slideName = previewStatus[index]?.slideName;
    let folderName = previewStatus[index]?.folderName;
    console.log("PROPS: ", props);
    const rack = slideStatus["cassetteSlide"]["rack"], tray = slideStatus["cassetteSlide"]["tray"];
    const disableScanButton = (!isTrue(enoughScanArea)) ||
        (barcodeVerify && isValidSlideName(slideName)) ||
        scanButtonStatus[index] || removeQueueInteraction ||
        isCalibrationPreview;

    function getScanButton() {
        return <Button
            className="black-scan-btn"
            onClick={(e) => {
                e.stopPropagation();
                props.queueScan(index);
            }}
            disabled={disableScanButton}
            style={{marginTop: "10px"}}>
            <ScanOutlined/>
            <span> Queue For Scan </span>
        </Button>;
    }

    return (
        <div style={{marginLeft: '25px'}}>
            <Row>
                <Input bordered="true" spellCheck="false" placeholder="Slide Name"
                       value={slideName}
                       style={barcodeVerify && isValidSlideName(slideName) ?
                           {borderColor: "red", width: "10vw", borderRadius: "0px"}
                           : {width: "10vw", borderRadius: "0px"}}
                       onChange={(e) =>
                           dispatch(
                               updateSlideName(e.target.value, rack, tray, index, deviceId)
                           )}>
                </Input>
            </Row>
            {
                addFolderAtPreview ?
                    <Row style={{height: 30, width: "10vw", marginTop: "5px"}}>
                        <CaseSearchInputComponent value={folderName}
                              folderName={folderName}
                              setFolderName={(val) =>
                                  dispatch(
                                      updateFolderName(val, rack, tray, index, deviceId)
                                  )}/>
                    </Row> : null
            }
            <Row style={{display: "flex", justifyContent: "flex-start"}}>
                {isCalibrationPreview ?
                    <Tooltip placement="top" title={"This scan cannot be started without skipping the preview Calibration or Finalizing scan settings"}>
                <Col>
                            {getScanButton()}
                </Col>
                    </Tooltip>
                    :
                    <Col>{getScanButton()}</Col>}
                <Col style={{marginLeft: 10}}>
                    <Tooltip placement="top" title={"Remove Preview"}>
                        <CancelOutlined style={{marginTop: "15px", cursor: "pointer"}}
                                        onClick={() => props.removePreview(index, isCalibrationPreview)} />
                    </Tooltip>
                </Col>
            </Row>
        </div>);
}

const ScanCrashedComponent = ({index, resetSlide,  previewButtonStatus, updatePreviewButtonStatus, removeQueueInteraction}) => {
    return (
        <div style={{marginLeft: '25px'}}>
            <Button
                className="black-scan-btn"
                size="large"
                onClick={(e) => {
                    e.stopPropagation();
                    updatePreviewButtonStatus(index, true);
                    resetSlide(index);
                }}
                disabled={previewButtonStatus[index] || removeQueueInteraction}>
                <EyeOutlined/>
                <span> Go back to Preview </span>
            </Button>
        </div>
    );
}

const ScanDoneComponent = ({index, resetSlide}) => {
    return (
        <div style={{marginLeft: '25px'}}>
            <Button
                className="scan-btn"
                size="large"
                onClick={(e) => {
                    e.stopPropagation();
                    resetSlide(index);
                }}
                disabled={false}>
                <CloseCircleOutlined style={{marginLeft: -5}}/>
                <span> Go back to Preview </span>
            </Button>
        </div>
    )
}

const SlideInitialisedComponent = (props) => {
    let {index, previewButtonStatus, updatePreviewButtonStatus, removeQueueInteraction, hasScanCalibrationPermission} = props;
    return (
        <div style={{marginLeft: '25px'}}>
            <Button
                className="scan-btn black-scan-btn"
                size="large"
                onClick={(e) => {
                    e.stopPropagation();
                    updatePreviewButtonStatus(index, true);
                    props.queuePreviewOnly(index);
                }}
                disabled={previewButtonStatus[index] || removeQueueInteraction}
                >
                <EyeOutlined/>
                <span> Queue Preview </span>
            </Button>
            {hasScanCalibrationPermission ?
            <Button
                className="scan-btn change-order-button"
                size="large"
                onClick={(e) => {
                    e.stopPropagation();
                    updatePreviewButtonStatus(index, true);
                    props.queuePreviewWithCalibration(index);
                }}
                disabled={previewButtonStatus[index] || removeQueueInteraction}
                style={{marginTop: "10px"}}
            >
                <EyeOutlined/>
                <span> Calibrate Scan </span>
            </Button> : null }
        </div>
    )
}

class C240SlideActionColumn extends Component {

    constructor(props) {
        super(props);
        this.state = {
            qPreviewBtnStatusMap: this.initQPreviewBtnStatus(),
            qScanBtnStatusMap: this.initQScanBtnStatus(),
        }
        this.SlideType = this.props.CassetteType === cassetteType.TWO_2_BY_3_SLIDES ?
            slideType.SLIDE_2_BY_3_INCH : slideType.SLIDE_1_BY_3_INCH;
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        let propsDiff = getObjectDifference(this.props, nextProps);
        let stateDiff = getObjectDifference(this.state, nextState);
        return !(Object.keys(propsDiff).length === 0 && Object.keys(stateDiff).length === 0);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let prevSlideState = (prevProps.slideStatus || {}).slideState;
        let slideState = (this.props.slideStatus || {}).slideState;
        if (prevSlideState !== slideState && slideState === C240SlideStatus.INITIAL) {
            this.updatePreviewButtonStatus(this.props.index, false);
        } else if (prevSlideState !== slideState && slideState === C240SlideStatus.PREVIEW_DONE) {
            this.updateScanButtonStatus(this.props.index, false);
        }

        if (prevProps.CassetteType !== this.props.CassetteType) {
            this.SlideType = this.props.CassetteType === cassetteType.TWO_2_BY_3_SLIDES ?
                slideType.SLIDE_2_BY_3_INCH : slideType.SLIDE_1_BY_3_INCH;
        }
    }

    initQPreviewBtnStatus = () => {
        let qPreviewBtnStatus = {};
        for (let rack = 0; rack < 2; rack++) {
            for (let tray = 0; tray < 20; tray++) {
                const cassette_key = `R${rack}T${tray}`;
                qPreviewBtnStatus[cassette_key] = Array(6).fill(false);
            }
        }
        return qPreviewBtnStatus;
    }

    initQScanBtnStatus = () => {
        let qScanBtnStatus = {};
        for (let rack = 0; rack < 2; rack++) {
            for (let tray = 0; tray < 20; tray++) {
                const cassette_key = `R${rack}T${tray}`;
                qScanBtnStatus[cassette_key] = Array(6).fill(false);
            }
        }
        return qScanBtnStatus;
    }

    getQueueElems = () => {
        return JSON.parse(JSON.stringify(this.props.queueState['queue']));
    }

    updateDeviceStatus = () => {
        this.props.dispatch(getDeviceStatus(this.props.deviceId));
    }

    updatePreviewButtonStatus = (slide_idx, status) => {
        let qPreviewBtnStatusMap = this.state.qPreviewBtnStatusMap;  // reference copy
        qPreviewBtnStatusMap[this.props.selectedCassette][slide_idx] = status;
        this.setState({
            qPreviewBtnStatusMap: qPreviewBtnStatusMap
        });
    }

    updateScanButtonStatus = (slide_idx, status) => {
        let qScanBtnStatusMap = this.state.qScanBtnStatusMap;
        qScanBtnStatusMap[this.props.selectedCassette][slide_idx] = status;
        this.setState({
            qPreviewBtnStatusMap: qScanBtnStatusMap
        });
    }

    resetSlide = (slideId) => {
        this.props.updateLoadingStatus(slideId, true);
        let {rack, tray} = getRackTrayFromCassetteKey(this.props.selectedCassette);
        const _this = this;
        callScannerServer("back_to_preview", `?rack=${rack}&tray=${tray}&slide=${slideId}`,
            () => {
                _this.props.updateLoadingStatus(slideId, false);
                _this.updateDeviceStatus();
            }, true);
    }

    prioritiseTask = (e, rack, tray, slide, taskType) => {
        appendToQueue(rack, tray, slide, null, taskType, queueActions.PRIORITISE, this.props.queueState, this.props.dispatch);
        callScannerServer("prioritise_task",
            `?rack=${rack}&tray=${tray}&slide=${slide}&taskType=${taskType}`,
            this.updateDeviceStatus, true)
    }

    deprioritiseTask = (e, rack, tray, slide, taskType) => {
        appendToQueue(rack, tray, slide, null, taskType, queueActions.DEPRIORITISE, this.props.queueState, this.props.dispatch);
        callScannerServer("de_prioritise_task",
            `?rack=${rack}&tray=${tray}&slide=${slide}&taskType=${taskType}`,
            this.updateDeviceStatus, true)
    }

    removeTask = (e, rack, tray, slide, taskType) => {
        appendToQueue(rack, tray, slide, null, taskType, queueActions.REMOVE, this.props.queueState, this.props.dispatch);
        callScannerServer("remove_task",
            `?rack=${rack}&tray=${tray}&slide=${slide}&taskType=${taskType}`,
            this.updateDeviceStatus, true);
    }

    queuePreviewOnly = (slideId) => {
        this.updatePreviewButtonStatus(slideId, true);
        let { rack, tray } = getRackTrayFromCassetteKey(this.props.selectedCassette);
        const _this = this;
        const callback = (resp) => {
            this.props.dispatch(getDeviceStatus(this.props.deviceId));
            this.props.dispatch(getC240Status());
        };

        appendToQueue(rack, tray, slideId, this.SlideType, c240TaskType.TAKE_SLIDE_PREVIEW, queueActions.ADD, this.props.queueState, this.props.dispatch);

        callScannerServer("queue_preview",
            `?rack=${rack}&tray=${tray}&slide=${slideId}&slide_type=${this.SlideType}`,
            callback, false, callback);
    }

    queuePreviewWithCalibration = (slideId) => {
        this.updatePreviewButtonStatus(slideId, true);
        let { rack, tray } = getRackTrayFromCassetteKey(this.props.selectedCassette);
        const _this = this;
        const callback = (resp) => {
            this.props.dispatch(getDeviceStatus(this.props.deviceId));
            this.props.dispatch(getC240Status());
        };

        const taskType = c240TaskType.TAKE_PREVIEW_FOR_CALIBRATION;
        const endpoint = "queue_preview_for_calibration";
        const userId = getLoggedInUserId();
        appendToQueue(rack, tray, slideId, this.SlideType, taskType, queueActions.ADD, this.props.queueState, this.props.dispatch);

        callScannerServer(endpoint,
            `?rack=${rack}&tray=${tray}&slide=${slideId}&slide_type=${this.SlideType}&user_id=${userId}`,
            callback, false, callback);
    }

    removePreview = (slideId, isCalibrationPreview = false) => {
        this.props.updateLoadingStatus(slideId, true);
        const { rack, tray } = getRackTrayFromCassetteKey(this.props.selectedCassette);
        const _this = this;
        const callback = function () {
            _this.props.dispatch(getDeviceStatus(_this.props.deviceId));
            _this.props.updateLoadingStatus(slideId, false);
        };
        let operationType = queueActions.REMOVE;
        if (isCalibrationPreview) {
            operationType = queueActions.REMOVE_PREVIEW_CALIBRATION;
        }
        updateQueueUIUtility(rack, tray, slideId, c240TaskType.TAKE_PREVIEW_FOR_CALIBRATION, operationType, null, this.props.queueState, null);
        callScannerServer("remove_preview",
            `?rack=${rack}&tray=${tray}&slide=${slideId}`, callback, true);
    }

    queueScan = (slideId) => {
        let {rack, tray} = getRackTrayFromCassetteKey(this.props.selectedCassette);
        const callback = (resp) => {
            this.props.dispatch(getDeviceStatus(this.props.deviceId));
            this.props.dispatch(getC240Status());
        };

        appendToQueue(rack, tray, slideId, this.SlideType, c240TaskType.TAKE_SCAN_OF_SELECTED_REGION, queueActions.ADD, this.props.queueState, this.props.dispatch);

        queueScan(
            `?rack=${rack}&tray=${tray}&slide=${slideId}&slide_type=${this.SlideType}`, callback, false);

    }

    render() {
        let {slideStatus, selectedCassette, queuePreview, index} = this.props;
        let slideState = (slideStatus || {}).slideState;
        const trayKey = this.props.selectedCassette; // eg: trayKey is "R1T1"
        let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        let tray = parseInt(trayKey.split("T")[1]);
        let slideInQueue = false;
        if (slideState === C240SlideStatus.PREVIEW_IN_QUEUE || slideState === C240SlideStatus.SCAN_IN_QUEUE ||
            slideState === C240SlideStatus.AUTO_SCAN_IN_QUEUE) {
            slideInQueue = true;
        }
        const queueElems = this.getQueueElems();
        const hasScanCalibrationPermission = hasPermissions([aclPermissions.scan_calibration])
        return (
            <Col span={7} style={{display: "flex", flexDirection: "column", justifyContent: "center", marginTop: "15px"}}>

                {(slideState === C240SlideStatus.SCAN_DONE) ?
                    <ScanDoneComponent index={index} resetSlide={this.resetSlide} /> : null}
                {slideState === C240SlideStatus.INITIAL ?
                    <SlideInitialisedComponent index={index}
                                               previewButtonStatus={this.state.qPreviewBtnStatusMap[selectedCassette]}
                                               removeQueueInteraction={false}
                                               updatePreviewButtonStatus={this.updatePreviewButtonStatus}
                                               queuePreviewOnly={this.queuePreviewOnly}
                                               queuePreviewWithCalibration={this.queuePreviewWithCalibration}
                                               hasScanCalibrationPermission={hasScanCalibrationPermission}
                    />
                    : null}
                {slideState === C240SlideStatus.SCAN_CRASHED ?
                    <ScanCrashedComponent index={index}
                                          removeQueueInteraction={false}
                                          previewButtonStatus={this.state.qPreviewBtnStatusMap[selectedCassette]}
                                          updatePreviewButtonStatus={this.updatePreviewButtonStatus}
                                          resetSlide={this.resetSlide} />
                    : null}
                {slideState === C240SlideStatus.PREVIEW_DONE ?
                    <PreviewDoneComponent
                        index={index}
                        selectedCassette={this.props.selectedCassette}
                        removeQueueInteraction={false}
                        removePreview={this.removePreview}
                        scanButtonStatus={this.state.qScanBtnStatusMap[selectedCassette]}
                        barcodeVerify={this.props.barcodeVerify}
                        deviceId={this.props.deviceId}
                        queueScan={this.queueScan}
                        slideStatus={slideStatus} />
                    : null}
                {slideInQueue ?
                    <SlideInQueueComponent
                        index={index}
                        queueElems={queueElems}
                        rack={rack} tray={tray}
                        prioritiseTask={this.prioritiseTask}
                        removeTask={this.removeTask}
                        deprioritiseTask={this.deprioritiseTask}
                    />
                    : null }
            </Col>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    };
}

export default connect(mapStateToProps)(C240SlideActionColumn);